"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calendarEventSchema = void 0;
const yup = __importStar(require("yup"));
const enums_1 = require("../../enums");
const user_event_relation_1 = require("../user-event-relation");
const event_formation_1 = require("./event-formation");
const utilities_1 = require("../../utilities");
const event_aircraft_detail_1 = require("./event-aircraft-detail");
const event_mission_detail_1 = require("./event-mission-detail");
const event_mission_profile_1 = require("./event-mission-profile");
const event_contract_detail_1 = require("./event-contract-detail");
const completion_detail_schema_1 = require("./completion-detail/completion-detail.schema");
exports.calendarEventSchema = yup.object().shape({
    id: yup.string().notRequired(),
    name: yup.string().required().required(),
    taskId: yup.string().notRequired().nullable(),
    type: yup.string().required().oneOf((0, utilities_1.getEnumValues)(enums_1.CalendarEventTypes)).required(),
    startDate: yup.number().min(1577851200000).max(2524622400000).required(),
    endDate: yup
        .number()
        .min(1577851200000)
        .max(2524622400000)
        .test('test-dates', 'End time should be after start time', utilities_1.compareDates)
        .required(),
    squadronId: yup.string().required(),
    usersEnrolled: yup.array().of(user_event_relation_1.userEventRelationSchema).notRequired(),
    isFull: yup.boolean().required(),
    note: yup.string().notRequired(),
    requestCount: yup.number().min(0).required(),
    isEventClosedByNotificationBell: yup.boolean().notRequired(),
    eventFormation: event_formation_1.eventFormationSchema.notRequired(),
    color: yup.string().notRequired(),
    aircraftDetail: event_aircraft_detail_1.eventAircraftDetailSchema.notRequired().nullable(),
    missionDetail: event_mission_detail_1.eventMissionDetailSchema.notRequired().nullable(),
    missionProfile: event_mission_profile_1.eventMissionProfileSchema.notRequired().nullable(),
    isManualSorting: yup.boolean().notRequired().default(false),
    contractDetail: event_contract_detail_1.eventContractDetailSchema.notRequired().nullable(),
    mainEventId: yup.string().notRequired(),
    isTrackable: yup.boolean().notRequired().default(true),
    completionDetail: completion_detail_schema_1.completionDetailSchema.notRequired().nullable(),
    stereoPlanRouteId: yup.string().notRequired().nullable(),
});
